import React from 'react'
import { FaChevronDown } from 'react-icons/fa6';
import './selectListButton.css'
import { RxCross2 } from 'react-icons/rx';

const SelectListButton = ({ onClick, selectTxt, crossIcon, crossIconOnlick }) => {

    const crossIconHandler = (event) => {
        event.stopPropagation();
        crossIconOnlick();
    }
    return (
        <div className="__modalSel_btn" onClick={onClick}>
            <div className="__modalSel_text">{selectTxt}</div>
            {crossIcon && <span className="clear-icon" onClick={(e) => crossIconHandler(e)}>
                <RxCross2 size={18} color="black" />
            </span>}
            <FaChevronDown />
        </div>
    )
}

export default SelectListButton